<template>
  <div class="bottom">
    <div class="header">
      <el-steps
        :active="active"
        align-center
        class="step"
        finish-status="success"
        process-status="finish"
      >
        <el-step title="基础设置"></el-step>
        <el-step title="规则设置"></el-step>
        <el-step title="奖品设置"></el-step>
        <el-step title="完成"></el-step>
      </el-steps>
    </div>
    <basicSettings v-if="active == 0" @active="getActive" />
    <ruleSetting v-if="active == 1" @active="getActive" />
    <prizeSetting v-if="active == 2" @active="getActive" />
    <Finish v-if="active == 3" @active="getActive" />
  </div>
</template>
<script>
import basicSettings from "@/views/apply/newVip/marketing/lottery/basicSettings";
import prizeSetting from "@/views/apply/newVip/marketing/lottery/prizeSetting";
import ruleSetting from "@/views/apply/newVip/marketing/lottery/ruleSetting";
import Finish from "@/views/apply/newVip/marketing/lottery/finish";

export default {
  components: {
    basicSettings,
    prizeSetting,
    ruleSetting,
    Finish
  },
  data() {
    return {
      active: 0
    };
  },
  mounted() {
    // alert('刷新不会保存您之前的操作!!!')

  },

  methods: {
    getActive(val) {
      console.log("111111");
      this.active = val;
    },
    getItem(i, img) {
      this.activeClass = i;
      this.img = img;
    },
    input(val) {
      this.topText = val;
    }
  }
};
</script>
<style lang="scss" scoped>
.bottom {
  width: 100%;
  height: 100%;
  background-color: #f8f8f8f8;

  .header {
    width: 95%;
    height: 5vw;
    background-color: #ffffff;
    margin: 10px auto;
    padding: 20px 0;
    box-sizing: border-box;
    // line-height: 5vw;
  }
}
</style>
